import dayjs from 'dayjs'
import customParseFormat from "dayjs/plugin/customParseFormat"

dayjs.extend(customParseFormat)

export const booking_engines = {

    "Travel Tripper" : {
        "checkin" : "CheckinDate",
        "checkout" : "departure_date",
        "date-engine-format" : "YYYY-MM-DD",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "children",
        "promo" : "accessCode",
        "group" : "group",
        cbBuildParams: function(params){
            let format = {}

            const triggers = {
                checkin: ( value ) =>{
                    let dateJs = dayjs(value , 'D-M-YYYY')
                    format = { ...format , CheckinDate : dateJs.format('YYYY-MM-DD') }
                    format = { ...format , "arrival_date" : dateJs.format('YYYY-MM-DD') }
                },
                checkout: ( value )=>{
                    let dateJs = dayjs(value , 'D-M-YYYY')
                    let checkinDate = dayjs( params['checkin'] , 'D-M-YYYY' )
                    format = { ...format , LOS : dateJs.diff(checkinDate , 'd')}
                    format = { ...format , 'departure_date' : dateJs.format('YYYY-MM-DD') }
                },
                rooms: ( rooms )=>{
                    let totalAdults = parseInt(params['adults']);
                    let totalChildren = params['children'].length==0 ? 0 : parseInt(params['children']);
                    
                    let adultsPerRoom = Math.floor(totalAdults / rooms);
                    const remainderAdult = totalAdults % rooms;
                    let childrenPerRoom = Math.floor(totalChildren / rooms);
                    const remainderChildren = totalChildren % rooms;
                    
                    let adultsPerRoomArray = [],
                        childrenPerRoomArray = [];
                    
                    for (let i = 0; i < rooms; i++) {
                        adultsPerRoomArray.push(adultsPerRoom);
                    }
                    
                    for (let i = 0; i < remainderAdult; i++) {
                        adultsPerRoomArray[i]++;
                    }

                    for (let i = 0; i < rooms; i++) {
                        childrenPerRoomArray.push(childrenPerRoom);
                    }

                    for (let i = 0; i < remainderChildren; i++) {
                        childrenPerRoomArray[i]++;
                    }

                    if(totalAdults > 0){
                        for (let i = 0; i < adultsPerRoomArray.length; i++) {
                            const roomNum = i+1;
                            const propertyNam = `Adults_${roomNum}`;
                            format = { ...format , [propertyNam]: adultsPerRoomArray[i] }
                        }
                    }
                    
                    if(totalChildren > 0){
                        for (let i = 0; i < childrenPerRoomArray.length; i++) {
                            const roomNum = i+1;
                            const propertyNam = `Children_${roomNum}`;
                            format = { ...format , [propertyNam]: childrenPerRoomArray[i] } 
                        }
                    }
                    
                    format = { ...format , Rooms: rooms }
                    format = { ...format , rooms: rooms }
                },
                children: ( value )=>{
                    format = { ...format , Children: value }
                    format = { ...format , children: value }
                },
                adults: ( value )=>{
                    format = { ...format , Adults: value }
                    format = { ...format , adults: value }
                },
                promo: (value)=>{
                    format = { ...format , 'accessCode': value }
                }
            }

            Object.keys(params).forEach( ( keyParam ) => {
                if( params[keyParam] !== "" ){
                    triggers[keyParam](params[keyParam]);
                }
            } )
            
            return format;
        }
    },
    "Synxis" : {
        "checkin" : "arrive",
        "checkout" : "depart",
        "date-engine-format" : "YYYY-MM-DD",
        "rooms" : "rooms",
        "adults" : "adult",
        "children" : "child",
        "promo" : "promo",
        "group" : "group"
    },
    "Windsurfer" : {
        "checkin" : "checkin",
        "checkout" : "checkout",
        "date-engine-format" : "MM/DD/YYYY",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "child",
        "promo" : "promo",
        "group" : "group"
    },
    "Your Reservation" : {
        "checkin" : "arrivaldate",
        "checkout" : "departuredate",
        "date-engine-format" : "MM-DD-YYYY",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "children",
        "promo" : "promo",
        "group" : "group"
    },
    "iHotelier" : {
        "checkin" : "DateIn",
        "checkout" : "DateOut",
        "date-engine-format" : "M/DD/YYYY",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "children",
        "promo" : "identifier",
        "group" : "group"
    },
    "ReservHotel" : {
        "checkin" : "aDate",
        "checkout" : "dDate",
        "date-engine-format" : "MM/DD/YYYY",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "child",
        "promo" : "PC",
        "group" : "group"
        //would need contain in the url the following query date_format=MM/DD/YYYY
    },
    "WebRezPro" : {
        "checkin" : "date_from",
        "checkout" : "date_to",
        "date-engine-format" : "YYYYMMDD",
        "rooms" : "rooms",
        "adults" : "num_adults",
        "children" : "num_children",
        "promo" : "access_code",
        "group" : "group"
    },
    "IQREZ" : {
        "checkin" : "checkin",
        "checkout" : "checkout",
        "date-engine-format" : "MM/DD/YYYY",
        "rooms" : "RMS",
        "adults" : "AD",
        "children" : "CH",
        "promo" : "promo",
        "group" : "group",
        cbBuildParams: function(params){
            let format = {}

            const triggers = {
                checkin: ( value ) =>{
                    let dateJs = dayjs(value , 'D/M/YYYY')
                    format = { 
                        ...format , 
                        CIM: dateJs.format('MM'),
                        CID: dateJs.format('DD'),
                        CIY: dateJs.format('YYYY')
                    }
                },
                checkout: ( value )=>{
                    let dateJs = dayjs(value , 'D/M/YYYY')
                    format = { 
                        ...format , 
                        COM: dateJs.format('MM'),
                        COD:  dateJs.format('DD'),
                        COY: dateJs.format('YYYY')
                    }
                },
                rooms: ( value )=>{
                    format = { ...format , RMS: value }
                },
                children: ( value )=>{
                    format = { ...format , CH: value }
                },
                adults: ( value )=>{
                    format = { ...format , AD: value }
                },
                promo: ( value )=>{
                    format = { ...format , promo: value }
                },
                group: (value)=>{
                    format = { ...format , group: value }
                }
            }

            Object.keys(params).forEach( ( keyParam ) => {
                if( params[keyParam] !== "" ){
                    triggers[keyParam](params[keyParam]);
                }
            } )

            return format
        }
    },
    "Cloud Beds" : {
        "checkin" : "checkin",
        "checkout" : "checkout",
        "date-engine-format" : "YYYY-MM-DD",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "children",
        "promo" : "promo",
        "group" : "group"
    },
    "Choice Hotels" : {
        "checkin" : "checkInDate",
        "checkout" : "checkOutDate",
        "date-engine-format" : "YYYY-MM-DD",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "minors",
        "promo" : "promo",
        "group" : "group"
    },
    "PHG Secure" : {
        "checkin" : "arrivalDate",
        "checkout" : "departureDate",
        "date-engine-format" : "MM/DD/YYYY",
        "rooms" : "numberOfRooms",
        "adults" : "room1NumAdults",
        "children" : "room1NumChildren",
        "promo" : "promo",
        "group" : "group",
        cbBuildParams: function(params){

            let format = {}

            const triggers = {
                checkout : ( value )=>{
                    let dateJs = dayjs(value , 'D-M-YYYY')
                    format = { ...format , departureDate : dateJs.format('YYYY-MM-DD') }
                },
                checkin : ( value )=>{
                    let dateJs = dayjs(value , 'D-M-YYYY')
                    format = { ...format , arrivalDate : dateJs.format('YYYY-MM-DD') }
                },
                rooms : ( rooms )=>{
                    let totalAdults = parseInt(params['adults']);
                    let totalChildren = params['children'].length==0 ? 0 : parseInt(params['children']);
                    
                    let adultsPerRoom = Math.floor(totalAdults / rooms);
                    const remainderAdult = totalAdults % rooms;
                    let childrenPerRoom = Math.floor(totalChildren / rooms);
                    const remainderChildren = totalChildren % rooms;
                    
                    let adultsPerRoomArray = [],
                        childrenPerRoomArray = [];
                    
                    for (let i = 0; i < rooms; i++) {
                        adultsPerRoomArray.push(adultsPerRoom);
                    }
                    
                    for (let i = 0; i < remainderAdult; i++) {
                        adultsPerRoomArray[i]++;
                    }

                    for (let i = 0; i < rooms; i++) {
                        childrenPerRoomArray.push(childrenPerRoom);
                    }

                    for (let i = 0; i < remainderChildren; i++) {
                        childrenPerRoomArray[i]++;
                    }

                    if(totalAdults > 0){
                        for (let i = 0; i < adultsPerRoomArray.length; i++) {
                            const roomNum = i+1;
                            const propertyNam = `room${roomNum}NumAdults`;
                            format = { ...format , [propertyNam]: adultsPerRoomArray[i] }
                        }
                    }

                    if(totalChildren > 0){
                        for (let i = 0; i < childrenPerRoomArray.length; i++) {
                            const roomNum = i+1;
                            const propertyNam = `room${roomNum}NumChildren`;
                            format = { ...format , [propertyNam]: childrenPerRoomArray[i] } 
                        }
                    }
                },
                adults : ( value )=>{
                    format = { ...format , adults: value }
                },
                children : ( value )=>{
                    format = { ...format , children: value }
                }
            }
            
            Object.keys(params).forEach( ( keyParam ) => {
                if( params[keyParam] !== "" ){
                    triggers[keyParam](params[keyParam]);
                }
            } )
            
            return format;
        }
    },
    "Wyndham" : {
        "checkin" : "checkin_date",
        "checkout" : "checkout_date",
        "date-engine-format" : "MM-DD-YYYY",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "children",
        "promo" : "promo",
        "group" : "group"
    },
    "Marriott" : {
        "checkin" : "fromDate",
        "checkout" : "toDate",
        "date-engine-format" : "MM/DD/YYYY",
        "rooms" : "numberOfRooms",
        "adults" : "numberOfGuests",
        "children" : "children",
        "promo" : "promo",
        "group" : "group"
    },
    "The Booking Button" : {
        "checkin" : "checkInDate",
        "checkout" : "checkOutDate",
        "date-engine-format" : "YYYY-MM-DD",
        "rooms" : "number_rooms",
        "adults" : "items[0][adults]",
        "children" : "items[0][children]",
        "promo" : "promo",
        "group" : "group"
    },
    "Book on the net" : {
        "checkin" : "arrival_date",
        "checkout" : "booking-checkout",
        "date-engine-format" : "YYYY-MM-DD",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "children",
        "promo" : "promo",
        "group" : "group",
        cbBuildParams: function(params){

            let format = {}

            const triggers = {
                checkin: ( value ) =>{
                    let dateJs = dayjs(value , 'D/M/YYYY')
                    format = { 
                        ...format , 
                        arrival_date: dateJs.format('YYYY-MM-DD')
                    }
                },
                checkout: ( value )=>{
                    let dateJs = dayjs(value , 'D/M/YYYY')
                    let arrival_date = dayjs( params['checkin'] , 'D/M/YYYY' )
                    console.log("checkout..." , dateJs.diff(arrival_date , 'd'))
                    format = { 
                        ...format , 
                        stay_nights: dateJs.diff(arrival_date , 'd')
                    }
                },
                rooms: ( value )=>{
                    format = { ...format , rooms: value }
                },
                children: ( value )=>{
                    format = { ...format , children: value }
                },
                adults: ( value )=>{
                    format = { ...format , adults: value }
                },
                promo: ()=>{

                },
                group: (value)=>{
                    format = { ...format , group: value }
                }
            }

            Object.keys(params).forEach( ( keyParam ) => {
                if( params[keyParam] !== "" ){
                    triggers[keyParam](params[keyParam]);
                }
            } )

            return format
        }
    },
    "Pegasus" : {
        "checkin" : "CheckinDate",
        "checkout" : "CheckoutDate",
        "date-engine-format" : "YYYY-MM-DD",
        "rooms" : "Rooms",
        "adults" : "adults",
        "children" : "children",
        "promo" : "offerCode",
        "group" : "group",
        cbBuildParams: function(params){
            let format = {}

            const triggers = {
                checkin: ( value ) =>{
                    let dateJs = dayjs(value , 'D-M-YYYY')
                    format = { ...format , CheckinDate : dateJs.format('YYYY-MM-DD') }
                },
                checkout: ( value )=>{
                    let dateJs = dayjs(value , 'D-M-YYYY')
                    let checkinDate = dayjs( params['checkin'] , 'D-M-YYYY' )
                    format = { ...format , 
                        CheckoutDate : dateJs.format('YYYY-MM-DD'),
                        LOS : dateJs.diff(checkinDate , 'd')
                     }
                },
                rooms: ( rooms )=>{
                    let totalAdults = parseInt(params['adults']);
                    let totalChildren = params['children'].length==0 ? 0 : parseInt(params['children']);
                    let adultsPerRoom = Math.floor(totalAdults / rooms);
                    const remainderAdult = totalAdults % rooms;
                    let childrenPerRoom = Math.floor(totalChildren / rooms);
                    const remainderChildren = totalChildren % rooms;
                    
                    let adultsPerRoomArray = [],
                        childrenPerRoomArray = [];
                    
                    for (let i = 0; i < rooms; i++) {
                        adultsPerRoomArray.push(adultsPerRoom);
                    }
                    
                    for (let i = 0; i < remainderAdult; i++) {
                        adultsPerRoomArray[i]++;
                    }

                    for (let i = 0; i < rooms; i++) {
                        childrenPerRoomArray.push(childrenPerRoom);
                    }

                    for (let i = 0; i < remainderChildren; i++) {
                        childrenPerRoomArray[i]++;
                    }

                    if(totalAdults > 0){
                        for (let i = 0; i < adultsPerRoomArray.length; i++) {
                            const roomNum = i+1;
                            const propertyNam = `Adults_${roomNum}`;
                            format = { ...format , [propertyNam]: adultsPerRoomArray[i] }
                        }
                    }
                    
                    if(totalChildren > 0){
                        for (let i = 0; i < childrenPerRoomArray.length; i++) {
                            const roomNum = i+1;
                            const propertyNam = `Children_${roomNum}`;
                            format = { ...format , [propertyNam]: childrenPerRoomArray[i] } 
                        }
                    }
                    format = { ...format , Rooms: rooms }
                },
                children: ( value )=>{
                },
                adults: ( value )=>{
                },
                promo: (value)=>{
                    format = { ...format , offerCode: value }
                },
                group: (value)=>{
                    format = { ...format , group: value }
                }
            }
            Object.keys(params).forEach( ( keyParam ) => {
                if( params[keyParam] !== "" ){
                    triggers[keyParam](params[keyParam]);
                }
            } )

            return format
        }
    },
    "ThinkReservations" : {
        "checkin" : "start_date",
        "checkout" : "end_date",
        "date-engine-format" : "YYYY-MM-DD",
        "rooms" : "number_of_rooms",
        "adults" : "number_of_adults",
        "children" : "number_of_children",
        "promo" : "coupon_code",
        "group" : "group"
    },
    "Best Western" : {
        "checkin" : "checkIn",
        "checkout" : "checkOut",
        "date-engine-format" : "MM-DD-YYYY",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "children",
        "promo" : "coupon_code",
        "group" : "group"
    },
    "Hyatt" : {
        "checkin" : "checkinDate",
        "checkout" : "checkoutDate",
        "date-engine-format" : "YYYY-MM-DD",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "kids",
        "promo" : "coupon_code",
        "group" : "group"
    },
    "IHG" : {
        "checkin" : "start_date",
        "checkout" : "end_date",
        "date-engine-format" : "DD/MM/YYYY",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "child",
        "promo" : "promo",
        "group" : "group",
        cbBuildParams: function(params){

            let format = {}

            const triggers = {
                checkin: ( value ) =>{
                    let dateJs = dayjs(value , 'D/M/YYYY')
                    format = { 
                        ...format , 
                        qCiMy: `${ parseInt(dateJs.format('M')) - 1 }${ dateJs.format('YYYY') }`,
                        qCiD: dateJs.format('D')
                    }
                },
                checkout: ( value )=>{
                    let dateJs = dayjs(value , 'D/M/YYYY')
                    format = { 
                        ...format , 
                        qCoMy: `${ parseInt(dateJs.format('M')) - 1 }${ dateJs.format('YYYY') }`,
                        qCoD: dateJs.format('D')
                    }
                },
                rooms: ( value )=>{
                    format = { ...format , qRms: value }
                },
                children: ( value )=>{
                    format = { ...format , qChld: value }
                },
                adults: ( value )=>{
                    format = { ...format , qAdlt: value }
                },
                promo: ()=>{

                },
                group: (value)=>{
                    format = { ...format , group: value }
                }
            }

            Object.keys(params).forEach( ( keyParam ) => {
                if( params[keyParam] !== "" ){
                    triggers[keyParam](params[keyParam]);
                }
            } )

            return format
        }
    },
    "Bookings10" : {
        "checkin" : "A",
        "checkout" : "D",
        "date-engine-format" : "MM/DD/YYYY",
        "rooms" : "rooms",
        "adults" : "Ad",
        "children" : "C",
        "promo" : "promo",
        "group" : "group"
    },
    "Room Cloud" : {
        "checkin" : "checkin",
        "checkout" : "checkout",
        "date-engine-format" : "YYYYMMDD",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "children",
        "promo" : "pin",
        "group" : "group"
    },
    "Direct Book" : {
        "checkin" : "start_year",
        "checkout" : "end_year",
        "date-engine-format" : "MM/DD/YYYY",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "children",
        "promo" : "promo",
        "group" : "group",
        cbBuildParams: function(params){

            let format = {}

            const triggers = {
                checkin: ( value ) =>{
                    let dateJs = dayjs(value , 'D/M/YYYY')
                    format = { 
                        ...format , 
                        checkInDate: dateJs.format('YYYY-MM-DD'),
                    }
                },
                checkout: ( value )=>{
                    let dateJs = dayjs(value , 'D/M/YYYY')
                    format = { 
                        ...format , 
                        checkOutDate: dateJs.format('YYYY-MM-DD'),
                    }
                },
                rooms: ( value )=>{
                    format = { ...format , rooms: value }
                },
                children: ( value )=>{
                    format = { ...format , 'items[0][children]': value }
                },
                adults: ( value )=>{
                    format = { ...format , 'items[0][adults]': value }
                },
                promo: (value)=>{
                    format = { ...format , promo: value }
                },
                group: (value)=>{
                    format = { ...format , group: value }
                }
            }

            Object.keys(params).forEach( ( keyParam ) => {
                if( params[keyParam] !== "" ){
                    triggers[keyParam](params[keyParam]);
                }
            } )

            return format
        }
    },
    "Stayntouch" : {
        "checkin" : "checkin",
        "checkout" : "checkout",
        "date-engine-format" : "MM-DD-YYYY",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "kids",
        "promo" : "promotionCode",
        "group" : "group"
    },
    "Scrippsinn" : {
        "checkin" : "startDate",
        "checkout" : "endDate",
        "date-engine-format" : "MMM D,YYYY",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "children",
        "promo" : "rateCode",
        "group" : "group"
    },
    "Vertical Booking" : {
        "checkin" : "checkin",
        "checkout" : "checkout",
        "date-format-js" : "mm-dd-yy",
        "date-format-php" : "m-d-Y",
        "room" : "rooms",
        "adult" : "tot_adulti",
        "children" : "tot_bambini",
        "promo" : "generic_codice",
        "group" : "group",
        cbBuildParams: function(params){

            let format = {}
            let initialDate;

            const triggers = {
                checkin: ( value ) =>{
                    let dateJs = dayjs(value , 'D/M/YYYY');
                    initialDate = dayjs(value , 'D/M/YYYY');
                    format = { 
                        ...format , 
                        gg: dateJs.format('D'),
                        mm: dateJs.format('M'),
                        aa: dateJs.format('YYYY')
                    }
                },
                checkout: ( value )=>{
                    let dateJs = dayjs(value , 'D/M/YYYY');
                    let diffTime = Math.abs(dateJs - initialDate);
                    let diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); 
                    format = {...format, notti_1:parseInt(diffDays)}
                    // format = { 
                    //     ...format , 
                    //     ggf: dateJs.format('D'),
                    //     mmf: dateJs.format('M'),
                    //     aaf: dateJs.format('YYYY')
                    // }
                },
                rooms: ( value )=>{
                
                    if(parseInt(value) > 1){
                        let numberGuests = params["children"] === '' ? parseInt(params["adults"]) : parseInt(params["adults"]) + parseInt(params["children"]);
                        let separateRooms = Math.ceil(parseInt(numberGuests)/2);
                        let totalGuests = numberGuests;

                        console.log(separateRooms);
                        for(let i = 1; i <= separateRooms; i++ ){
                            let nameValue = 'adulti' + i;
                            let nGuest = totalGuests !== 1 ? (numberGuests === parseInt(value)) ? 1 : 2 :1;
                            format = { ...format , [nameValue]: nGuest }
                            totalGuests = totalGuests - 2; 
                        }
                    } 
                    format = { ...format , tot_camere: value }
                },
                children: ( value )=>{
                    format = { ...format , tot_bambini: value }
                },
                adults: ( value )=>{
                    format = { ...format , tot_adulti: value }
                },
                promo: (value)=>{
                    format = { ...format , generic_codice: value }
                },
                group: (value)=>{
                    format = { ...format , group: value }
                }
            }

            

            Object.keys(params).forEach( ( keyParam ) => {
                if( params[keyParam] !== "" ){
                    triggers[keyParam](params[keyParam]);
                }
            } )
            if(params["children"] === ''){
                format = { ...format , tot_bambini : 0 }
            }

            return format
        }
    },
    "Mews" : {
        "checkin" : "mewsStart",
        "checkout" : "mewsEnd",
        "date-engine-format" : "YYYY-MM-DD",
        "rooms" : "mewsRoom",
        "adults" : "mewsAdultCount",
        "children" : "mewsChildCount",
        "promo" : "mewsVoucherCode",
        "group" : "group"
    },
    "Resnexus" : {
        "checkin" : "StartDate",
        "checkout" : "EndDate",
        "date-engine-format" : "YYYY-MM-DD",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "children",
        "promo" : "promo",
        "group" : "group"
    },
    "ResEze" : {
        "checkin" : "checkin",
        "checkout" : "checkout",
        "date-format-js" : "mm/dd/yy",
        "date-format-php" : "m/d/Y",
        "rooms" : "numberRooms",
        "adults" : "adults",
        "children" : "children",
        "promo" : "rateCode",
        "hotelid" : "hotelid",
        "group" : "groupId",
        cbBuildParams: function(params){

            let format = {}

            const triggers = {
                checkin: ( value ) =>{
                    let dateJs = dayjs(value , 'D/M/YYYY')
                    const currentUrl = window.location.href.replace('#','')+'#_booking';
                    let clientId = site_id;
                    format = { 
                        ...format , 
                        arrivalDay: dateJs.format('D'),
                        arrivalMonth: parseInt(dateJs.format('M'))-1,
                        arrivalYear: dateJs.format('YYYY'),
                        returnurl: encodeURIComponent(currentUrl)
                    }
                },
                checkout: ( value )=>{
                    let dateJs = dayjs(value , 'D/M/YYYY')
                    let checkinDate = dayjs( params['checkin'] , 'D/M/YYYY' )
                    format = { 
                        ...format ,
                        nightsStay : dateJs.diff(checkinDate , 'd'),
                    }
                },
                rooms: ( value )=>{
                    format = { ...format , numberRooms: value }
                },
                children: ( value )=>{
                    format = { ...format , children: value }
                },
                adults: ( value )=>{
                    format = { ...format , adults: value }
                },
                promo: (value)=>{
                    format = { ...format , rateCode: value }
                },
                group: (value)=>{
                    format = { ...format , groupId: value }
                },
            }

            Object.keys(params).forEach( ( keyParam ) => {
                if( params[keyParam] !== "" ){
                    triggers[keyParam](params[keyParam]);
                }
            } )
            
            return format;
        }
    },
    "Sonesta" : {
        "checkin" : "checkIn",
        "checkout" : "checkOut",
        "date-engine-format" : "YYYY-MM-DD",
        "room" : "rooms",
        "adults" : "adult",
        "children" : "child",
        "promo" : "promo"
    },
    "Ennismore" : {
        "checkin" : "checkin",
        "checkout" : "checkout",
        "date-engine-format" : "MM/DD/YYYY",
        "rooms" : "rooms",
        "adults" : "adult",
        "children" : "children",
        "rate" : "rateCode",
        "promo" : "promo",
        cbBuildParams: function(params){
            let format = {}

            const triggers = {
                checkin: ( value ) =>{
                    let dateJs = dayjs(value , 'D-M-YYYY')
                    format = { ...format , checkin : dateJs.format('YYYY-MM-DD') }
                },
                checkout: ( value )=>{
                    let dateJs = dayjs(value , 'D-M-YYYY')
                    format = { ...format , checkout : dateJs.format('YYYY-MM-DD') }
                },
                rooms: ( rooms )=>{
                    
                    let totalAdults = parseInt(params['adults']);
                    let totalChildren = params['children'].length==0 ? 0 : parseInt(params['children']);
                    
                    let adultsPerRoom = Math.floor(totalAdults / rooms);
                    const remainderAdult = totalAdults % rooms;
                    let childrenPerRoom = Math.floor(totalChildren / rooms);
                    const remainderChildren = totalChildren % rooms;
                    
                    let adultsPerRoomArray = [],
                    childrenPerRoomArray = [];

                    for (let i = 0; i < rooms; i++) {
                        adultsPerRoomArray.push(adultsPerRoom);
                    }
                    
                    for (let i = 0; i < remainderAdult; i++) {
                        adultsPerRoomArray[i]++;
                    }

                    for (let i = 0; i < rooms; i++) {
                        childrenPerRoomArray.push(childrenPerRoom);
                    }

                    for (let i = 0; i < remainderChildren; i++) {
                        childrenPerRoomArray[i]++;
                    }

                    if(totalAdults > 0){
                        for (let i = 0; i < adultsPerRoomArray.length; i++) {
                            const roomNum = i;
                            const propertyNam = encodeURIComponent(`rooms[${roomNum}].adults`);
                            format = { ...format , [propertyNam]: adultsPerRoomArray[i] }
                        }
                    }

                    if(totalChildren > 0){
                        for (let i = 0; i < childrenPerRoomArray.length; i++) {
                            const roomNum = i;
                            const propertyNam = encodeURIComponent(`rooms[${roomNum}]children`);
                            format = { ...format , [propertyNam]: childrenPerRoomArray[i] } 
                        }
                    }
                },
                children: ( value )=>{
                },
                adults: ( value )=>{
                },
                promo: ( value )=>{
                    format = { ...format , promo: value }
                },
                rate: ( value )=>{
                    format = { ...format , rateCode: value }
                }
            }

            Object.keys(params).forEach( ( keyParam ) => {
                if( params[keyParam] !== "" ){
                    triggers[keyParam](params[keyParam]);
                }
            } )

            return format
        }
    },
    "IRMng" : {
        "checkin" : "arrival",
        "checkout" : "departure",
        "date-format-js" : "yyyy/mm/dd",
        "date-engine-format" : "YYYY-MM-DD",
        "rooms" : "roomnum",
        "adults" : "people1",
        "children" : "children",
        "rate" : "rateplan",
        "promo" : "promocode"
    },
    "SiteMinder" : {
        "checkin" : "check_in_date",
        "checkout" : "check_out_date",
        "date-format-js" : "yyyy-mm-dd",
        "date-engine-format" : "YYYY-MM-DD",
        "rooms" : "rooms",
        "adults" : "number_adults",
        "children" : "number_children",
        "rate" : "rate_plan",
        "promo" : "promotion_code"
    },
    "Fuel" : {
        "checkin" : "Checkin",
        "checkout" : "Checkout",
        "date-format-js" : "mm/dd/yyyy",
        "date-engine-format" : "MM/DD/YYYY",
        "rooms" : "Rooms",
        "adults" : "Adults",
        "children" : "Children",
        "promo" : "PromoCode",
        "group" : "Group"
    },
    "P3 Booking" : {
        "checkin" : "arrival",
        "checkout" : "departure",
        "date-format-js" : "mm/dd/yyyy",
        "date-engine-format" : "YYYY-MM-DD",
        "rooms" : "rooms",
        "adults" : "adults",
        "children" : "children",
        "promo" : "code",
        cbBuildParams: function(params){
            let format = {}

            const triggers = {
                checkin: ( value ) =>{
                    let dateJs = dayjs(value , 'D-M-YYYY')
                    format = { ...format , arrival : dateJs.format('YYYY-MM-DD') }
                },
                checkout: ( value )=>{
                    let dateJs = dayjs(value , 'D-M-YYYY')
                    format = { ...format , departure : dateJs.format('YYYY-MM-DD') }
                },
                rooms: ( rooms )=>{
                    let totalAdults = parseInt(params['adults']);
                    let totalChildren = params['children'].length==0 ? 0 : parseInt(params['children']);
                    let adultsPerRoom = Math.floor(totalAdults / rooms);
                    const remainderAdult = totalAdults % rooms;
                    let childrenPerRoom = Math.floor(totalChildren / rooms);
                    const remainderChildren = totalChildren % rooms;
                    
                    let adultsPerRoomArray = [],
                        childrenPerRoomArray = [];
                    
                    for (let i = 0; i < rooms; i++) {
                        adultsPerRoomArray.push(adultsPerRoom);
                    }
                    
                    for (let i = 0; i < remainderAdult; i++) {
                        adultsPerRoomArray[i]++;
                    }

                    for (let i = 0; i < rooms; i++) {
                        childrenPerRoomArray.push(childrenPerRoom);
                    }

                    for (let i = 0; i < remainderChildren; i++) {
                        childrenPerRoomArray[i]++;
                    }

                    if(totalAdults > 0){
                        for (let i = 0; i < adultsPerRoomArray.length; i++) {
                            const roomNum = i+1;
                            const propertyNam = `adults[${roomNum}]`;
                            format = { ...format , [propertyNam]: adultsPerRoomArray[i] }
                        }
                    }
                    
                    if(totalChildren > 0){
                        for (let i = 0; i < childrenPerRoomArray.length; i++) {
                            const roomNum = i+1;
                            const propertyNam = `children[${roomNum}]`;
                            format = { ...format , [propertyNam]: childrenPerRoomArray[i] } 
                        }
                    }
                    format = { ...format , rooms: rooms }
                },
                children: ( value )=>{
                },
                adults: ( value )=>{
                },
                promo: (value)=>{
                    format = { ...format , code: value }
                },
            }
            Object.keys(params).forEach( ( keyParam ) => {
                if( params[keyParam] !== "" ){
                    triggers[keyParam](params[keyParam]);
                }
            } )

            return format;
        }
    }
}
